// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3i6YM","questions":"styles_questions__38qMf","footer":"styles_footer__1Eqc5"};